/* eslint-disable no-nested-ternary */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '../../../../../../../utils';
import {
  CARD_CONTENT_PADDING,
  ORDER_LEDGER,
} from '../../../../SinglePageCheckout/views/SinglePageCheckoutPage.style.constants';

const getMarginBottom = (props) => {
  const { spc, orderSubtotalEnhancementEnabled, theme } = props;

  if (spc || orderSubtotalEnhancementEnabled) {
    return orderSubtotalEnhancementEnabled
      ? ORDER_LEDGER.ROW.MARGIN_BOTTOM_1
      : ORDER_LEDGER.ROW.MARGIN_BOTTOM;
  }

  return theme.spacing.ELEM_SPACING.XS;
};

const LedgerStyle = css`
  background-color: ${(props) => {
    return props.theme.colors.WHITE;
  }};
  padding: ${(props) => (props.spc ? '0px' : '23px 1px 21px')};
  padding-bottom: 0;
  .item-closed {
    .elem-mb-MED {
      margin-bottom: 0;
    }
  }
  .spc-header {
    display: flex;
    justify-content: space-between;
    padding-right: ${(props) => (props.spc ? '0px' : '35px')};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
  }
  .seperator {
    width: 30%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    line-height: 0.1em;
  }

  .seperator-style {
    background: ${(props) => props.theme.colors.WHITE};
    padding: 0 10px;
    line-height: 0.1em;
  }
  .order-summary-header-price {
    margin-right: 18px;
  }

  .expanded-header .order-summary-header-price,
  .collapsed-header .order-summary-header-title {
    ${(props) => (props.spc ? 'display: none;' : '')}
  }

  .collapsed-header .order-summary-header-title {
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) => (props.spc ? 'display: inline;' : '')}
    }
  }

  .order-summary-action {
    display: flex;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => (props.spc ? 'display: none;' : '')}
    }
  }

  .order-summary-action::after {
    content: '';
    padding: 0 9px;
    height: 10px;
  }

  .expanded-header .order-summary-action::after {
    background: transparent url('${(props) => getIconPath('up_arrow_toggle', props)}') no-repeat
      right center;

    @media ${(props) => props.theme.mediaQuery.medium} {
      background: transparent url('${(props) => getIconPath('up_arrow_icon', props)}') no-repeat
        right center;
    }
  }

  .collapsed-header .order-summary-action::after {
    background: transparent url('${(props) => getIconPath('down_arrow_toggle', props)}') no-repeat
      right center;

    @media ${(props) => props.theme.mediaQuery.medium} {
      background: transparent url('${(props) => getIconPath('down_arrow_icon', props)}') no-repeat
        right center;
    }
  }

  .rowMargin {
    margin-left: ${(props) => (props.spc ? 0 : '16px')};
    margin-right: ${(props) => (props.spc ? 0 : '16px')};
    width: ${(props) => (props.spc ? '100%' : 'calc(100% - 28px)')};
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-left: ${(props) => (props.spc ? 0 : '16px')};
      margin-right: ${(props) => (props.spc ? 0 : '16px')};
      width: ${(props) => (props.spc ? '100%' : 'calc(100% - 30px)')};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: ${(props) => (props.spc ? 0 : '16px')};
      margin-right: ${(props) => (props.spc ? 0 : '16px')};
      width: ${(props) => (props.spc ? '100%' : 'calc(100% - 28px)')};
    }
    margin-bottom: ${(props) => getMarginBottom(props)};
  }
  .estimated-total {
    padding-top: 10px;
  }
  .balance-total-confirmation.rowMargin {
    margin-bottom: 0px;
  }
  .tax-total {
    padding-bottom: ${(props) =>
      props.spc
        ? ORDER_LEDGER.TAX.PADDING_BOTTOM
        : props.orderSubtotalEnhancementEnabled
        ? '16px'
        : '7px'};
    border-bottom: 1px solid ${(props) => props.theme.colors.BORDER.GRAY};
  }
  .after-pay-msg {
    ${(props) =>
      !props.orderSubtotalEnhancementEnabled &&
      `border-bottom: 1px solid ${props.theme.colors.PRIMARY.GRAY};`}
    text-align: center;
    padding-bottom: 7px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      border-bottom: 0px solid ${(props) => props.theme.colors.PRIMARY.GRAY};
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
    margin-right: 16px;
    margin-left: 16px;
  }
  .after-pay-msg .afterPayMessagingWrapper {
    ${(props) =>
      props.orderSubtotalEnhancementEnabled &&
      ` justify-content: flex-start;
      margin-top: -13px;`}
  }
  .circle-info-image {
    width: 15px;
    height: 15px;
    position: relative;
    left: 5px;
    top: 2px;
  }
  .tooltip-bubble {
    left: 100%;
    ::after {
      right: 42%;
    }

    ::before {
      right: 39%;
    }
  }
  .tooltip-message p {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
  }
  .balance-total-price {
    ${(props) =>
      props.orderSubtotalEnhancementEnabled &&
      `color: ${props.theme.colorPalette.red[1000]};font-weight: ${props.theme.fonts.fontWeight.extrabold};
    `};
  }
  .text-style-change {
    line-height: 200%;
  }
  .strike-through-line {
    text-decoration: line-through;
    text-decoration-thickness: 1px;
  }
  .balance-total-columns {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.typography.fontSizes.fs18};
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    line-height: ${(props) => props.theme.fonts.lineHeight.normal};
    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs18};
    }
  }

  .order-ledger-header {
    text-align: left;
  }

  .expanded-header .order-ledger-header {
    padding-bottom: ${(props) =>
      props.spc ? CARD_CONTENT_PADDING.TOP : props.theme.spacing.LAYOUT_SPACING.XS};
  }

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    background-color: ${(props) => props.theme.colors.WHITE};
  }

  .orderLedgerAccordian {
    .collapsible-header {
      background-color: ${(props) => props.theme.colorPalette.white};
      padding-top: ${(props) =>
        props.spc
          ? ORDER_LEDGER.COLLAPSIBLE_HEADER.PADDING_TOP
          : props.theme.spacing.ELEM_SPACING.MED};
      padding-left: ${(props) =>
        props.spc
          ? ORDER_LEDGER.COLLAPSIBLE_HEADER.PADDING_LEFT
          : props.theme.spacing.ELEM_SPACING.SM};
    }
    .collapsible-icon {
      top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
      right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
  }

  &.order-confirmation {
    .order-ledger-header {
      @media ${(props) =>
          props.spc ? props.theme.mediaQuery.mediumMax : props.theme.mediaQuery.smallOnly} {
        display: block;
      }
    }
    .item-closed {
      display: block;
      padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
  }

  .orderLedgerLoyalty {
    ${(props) =>
      props.newBag && props.isNewLoyaltyBanner && !props.isPlcc
        ? `padding: ${props.theme.spacing.ELEM_SPACING.SM}`
        : ''};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.newBag && props.isNewLoyaltyBanner && !props.isPlcc
          ? `padding: ${props.theme.spacing.ELEM_SPACING.SM} ${props.theme.spacing.ELEM_SPACING.XXS} ${props.theme.spacing.ELEM_SPACING.XXS}`
          : ''};
    }
    ${(props) =>
      props.pageCategory === 'confirmation' && !props.spc
        ? `
        @media ${props.theme.mediaQuery.medium} {
          display: none;
        }
        @media ${props.theme.mediaQuery.large} {
          display: none;
        }
        `
        : ''}
    ${(props) =>
      props.pageCategory === 'confirmation' && props.spc
        ? `
        @media ${props.theme.mediaQuery.small} {
          display: none;
        }
        `
        : ''}

        @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => (props.spc ? 'margin-top: 0px' : '')}
    }
  }

  .venmo-payment-method-wrapper {
    display: flex;
    flex-direction: row;
    text-align: left;
    margin-left: 14px;
  }

  .cardImage-wrapper {
    display: flex;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }

  .cardImage-img-wrapper {
    display: flex;
    border: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    background-color: ${(props) => props.theme.colors.WHITE};

    .cardImage-img {
      width: 47px;
      height: 30px;
    }
  }

  .venmo-paid-text {
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }

  .summary-heading {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.typography.fontSizes.fs18};
    font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
    ${(props) =>
      props.orderSubtotalEnhancementEnabled &&
      !props.spc &&
      !props.isConfirmationPage &&
      `margin-left: 16px;margin-bottom: 20px;`}

    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs18};
    }
  }
  .spc-header.spc-card-heading {
    margin: 0;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: ${(props) => (props.spc ? 0 : '8px')};
    }
  }
  .spc-order-ledger-col {
    margin-right: 0px;
  }
  span.order-summary-header-title {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
    letter-spacing: 0.64px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }
  .zip-error {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .rowFreeShippingMargin {
    margin: ${(props) => (props.spc ? 0 : '0px 16px')};
    ${(props) => props.spc && `width: 100%;`};
  }
  .horizontal-line {
    margin: ${(props) => (props.spc ? 0 : '0px 14px')};

    border-top: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    ${(props) => props.orderSubtotalEnhancementEnabled && `padding-top:16px;`}
  }
`;

export default LedgerStyle;
